import { createModalContext, useModalState } from '@/common/app/modal'
import { ChildProps } from '@/common/util/props'

import WidgetCssModal from '@/components/container/modal/widget/css/WidgetCssModal'

interface WidgetCssModalState {
  customCss: string
}

const defaultValue = {
  customCss: ''
}

export const WidgetCssModalContext = createModalContext<WidgetCssModalState>(defaultValue)

const WidgetCssModalProvider = ({ children }: ChildProps) => {
  const state = useModalState<WidgetCssModalState>(defaultValue)
  return (
    <WidgetCssModalContext.Provider value={state}>
      {children}
      <WidgetCssModal />
    </WidgetCssModalContext.Provider>
  )
}

export default WidgetCssModalProvider
